import type { Editor } from '@tiptap/react';
import React, { useEffect, useRef, useState } from 'react';
import { FaAlignCenter, FaAlignLeft, FaAlignRight } from 'react-icons/fa';

import { EditorFeatures } from '../../types';

interface TextAlignmentToolbarProps {
  editor: Editor | null;
  features: Pick<EditorFeatures, 'textStyles'>;
  refreshActiveState: () => void;
}

export const TextAlignmentToolbar: React.FC<TextAlignmentToolbarProps> = ({
  editor,
  features,
  refreshActiveState,
}) => {
  const [showAlignDropdown, setShowAlignDropdown] = useState(false);
  const alignDropdownRef = useRef<HTMLDivElement | null>(null);

  // Click outside handler
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (alignDropdownRef.current && !alignDropdownRef.current.contains(event.target as Node)) {
        setShowAlignDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (!features.textStyles || !editor) {
    return null;
  }

  return (
    <div
      ref={alignDropdownRef}
      className='dropdownWrapper'
      title='水平方向の配置'
    >
      <button
        onClick={() => setShowAlignDropdown(!showAlignDropdown)}
        className={`toolbar-button ${
          editor?.isActive({ textAlign: 'left' }) ||
          editor?.isActive({ textAlign: 'center' }) ||
          editor?.isActive({ textAlign: 'right' })
            ? 'active'
            : ''
        }`}
        type='button'
      >
        {editor?.isActive({ textAlign: 'center' }) ? (
          <FaAlignCenter />
        ) : editor?.isActive({ textAlign: 'right' }) ? (
          <FaAlignRight />
        ) : (
          <FaAlignLeft />
        )}
      </button>
      {showAlignDropdown && (
        <div className='dropdownMenu textAlignMenu'>
          <div
            className={`dropdownItem toolbar-button ${
              editor?.isActive({ textAlign: 'left' }) ? 'active' : ''
            }`}
            onClick={() => {
              if (editor.isActive('image')) {
                editor.view.dom.focus({ preventScroll: true });
                editor.chain().updateAttributes('image', { textAlign: 'left' }).run();
              } else {
                editor.view.dom.focus({ preventScroll: true });
                editor.chain().setTextAlign('left').run();
              }
              setShowAlignDropdown(false);
              refreshActiveState();
            }}
          >
            <FaAlignLeft />
          </div>
          <div
            className={`dropdownItem toolbar-button ${
              editor?.isActive({ textAlign: 'center' }) ? 'active' : ''
            }`}
            onClick={() => {
              if (editor.isActive('image')) {
                editor.view.dom.focus({ preventScroll: true });
                editor.chain().updateAttributes('image', { textAlign: 'center' }).run();
              } else {
                editor.view.dom.focus({ preventScroll: true });
                editor.chain().setTextAlign('center').run();
              }
              setShowAlignDropdown(false);
              refreshActiveState();
            }}
          >
            <FaAlignCenter />
          </div>
          <div
            className={`dropdownItem toolbar-button ${
              editor?.isActive({ textAlign: 'right' }) ? 'active' : ''
            }`}
            onClick={() => {
              if (editor.isActive('image')) {
                editor.view.dom.focus({ preventScroll: true });
                editor.chain().updateAttributes('image', { textAlign: 'right' }).run();
              } else {
                editor.view.dom.focus({ preventScroll: true });
                editor.chain().setTextAlign('right').run();
              }
              setShowAlignDropdown(false);
              refreshActiveState();
            }}
          >
            <FaAlignRight />
          </div>
        </div>
      )}
    </div>
  );
};
